import SecureLS from 'secure-ls'

const SHARED_SESSION_NAMESPACE = 'znap-session'
const SHARED_HASH_KEY = 'znap-session-hash'

const sharedSessionStorage = new SecureLS({
    encryptionNamespace: SHARED_SESSION_NAMESPACE,
    isCompression: false,
})

export function readSharedHash() {
    try {
        return sharedSessionStorage.get(SHARED_HASH_KEY) || null
    } catch {
        return null
    }
}

export function writeSharedHash(hash) {
    sharedSessionStorage.set(SHARED_HASH_KEY, hash)
}

export function clearSharedHash() {
    sharedSessionStorage.remove(SHARED_HASH_KEY)
}

export function syncSharedHash(store) {
    store.subscribe((mutation) => {
        if (mutation.type === 'auth/setHash' && mutation.payload) writeSharedHash(mutation.payload)
        if (mutation.type === 'auth/resetState') clearSharedHash()
    })
}
